import { useEffect, useRef, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Clock, LogIn, X } from "lucide-react";

export default function ClockInPrompt() {
  const { user, justLoggedIn, consumeJustLoggedIn } = useAuth();
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const fired = useRef(false);

  useEffect(() => {
    if (!user || !justLoggedIn || fired.current) return;
    if (user.must_change_password) return; // que primero cambie pwd
    fired.current = true;
    (async () => {
      try {
        const r = await api.post("/time-clock/auto-on-login");
        if (r.data.created) {
          toast.success("Fichaje de entrada registrado automáticamente.");
        } else if (r.data.should_prompt) {
          setOpen(true);
        }
      } catch (e) {
        // silencioso: no bloquear login
        console.warn("auto-on-login error", e);
      } finally {
        consumeJustLoggedIn();
      }
    })();
  }, [user, justLoggedIn, consumeJustLoggedIn]);

  const confirm = async () => {
    setSubmitting(true);
    try {
      const r = await api.post("/time-clock/confirm-login");
      if (r.data.created) toast.success("Entrada registrada");
      setOpen(false);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSubmitting(false);
    }
  };

  const skip = () => setOpen(false);

  if (!open || !user) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-[60] flex items-center justify-center p-4">
      <div className="bg-white border border-[#111110] shadow-hard w-full max-w-md">
        <div className="px-5 py-4 border-b border-[#E5E5E0] flex items-center gap-3">
          <div className="w-9 h-9 bg-[#111110] text-[#6E8B3D] flex items-center justify-center">
            <Clock size={18} strokeWidth={2.2} />
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-[#6E8B3D]">
              // Control horario
            </div>
            <div className="font-display font-black text-base">Fichar entrada</div>
          </div>
        </div>
        <div className="p-5 space-y-3">
          <p className="text-sm">
            Hola <span className="font-semibold">{user.name}</span>. Todavía no has fichado entrada hoy. ¿Quieres fichar entrada ahora?
          </p>
          <p className="text-[11px] text-[#525252] font-mono">
            La hora se registra con el reloj del servidor.
          </p>
          <div className="flex gap-2 pt-2">
            <button
              onClick={skip}
              data-testid="clockin-prompt-skip"
              className="flex-1 inline-flex items-center justify-center gap-1 border border-[#111110] px-3 py-2 text-sm hover:bg-[#F7F7F4]"
            >
              <X size={13} /> Más tarde
            </button>
            <button
              onClick={confirm}
              disabled={submitting}
              data-testid="clockin-prompt-confirm"
              className="flex-1 inline-flex items-center justify-center gap-1 bg-[#6E8B3D] hover:bg-[#556C2E] text-white px-3 py-2 text-sm font-semibold disabled:opacity-50"
            >
              <LogIn size={13} /> {submitting ? "..." : "Fichar entrada"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
